var fonSize = window.innerWidth < 500 ? 9 : 12
export const chartDefaults = {
    barHorizontalRegiones: {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: true,
                borderColor: '#000',
                borderWidth: 0.5,
                titleColor: '#000',
                bodyColor: '#000',
                backgroundColor: '#fff',
                callbacks: {
                    label: function(data) {
                        return data.formattedValue + '%'
                    },
                }
            }
        },
        layout: {
            padding: {
                right: 15,
                left: 10,
                top: 16,
                bottom: 16
            }
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Cobertura (%)',
                font: {
                    size: 15,
                    weight: 'bold',
                    lineHeight: 1.2,
                },
                },
                grid: {
                    display: true,
                    drawTicks: false,
                    tickMarkLength: 5,
                    drawBorder: false
                },
                ticks: {
                    padding: 5,
                    beginAtZero: false,
                }
            },
            y: {
                reverse:true,
                title: {
                    display: true,
                    text: 'Tramo de edad',
                font: {
                    size: 15,
                    weight: 'bold',
                    lineHeight: 1.2,
                },
                },
                barPercentage: 1,
                grid: {
                    display: true,
                    drawTicks: true,
                    drawOnChartArea: false
                },
                ticks: {
                    beginAtZero: true,
                    lineHeight: 2,
                    padding: 10,
                    maxTicksLimit: 20,
                    autoSkip: true,
                font: {
                    size: fonSize,
                },
                }
            },
        }
    },
    barHorizontalMundial: {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
        tooltip: {
            enabled: true,
            borderColor: '#000',
            borderWidth: 0.5,
            titleColor: '#000',
            bodyColor: '#000',
            backgroundColor: '#fff',
            callbacks: {
                label: function(data) {
                    return data.formattedValue + '% de inmunizados'
                },
            }
        },
        },
        layout: {
            padding: {
                right: 15,
                left: 10,
                top: 16,
                bottom: 16,
            }
        },
        scales: {
            x: {
                title: {
                    display: false,
                    text: 'Cobertura de (%)'
                },
                grid: {
                    display: true,
                    drawTicks: false,
                    tickMarkLength: 5,
                    drawBorder: false
                },
                ticks: {
                    padding: 5,
                    beginAtZero: true,
                }
            },
            y: {
                reverse:true,
                title: {
                    display: false,
                    text: 'Grupo de edad'
                },
                barPercentage: 1,
                grid: {
                    display: true,
                    drawTicks: true,
                    drawOnChartArea: false
                },
                ticks: {
                    beginAtZero: true,
                    lineHeight: 2,
                    padding: 10,
                    maxTicksLimit: 20,
                    autoSkip: true
                }
            },
        }
    }
}